import React, {useState, useEffect} from "react";
import firebase from "services/firebase";
import useUI from "hooks/ui.hook";
import {Spinner, Button} from "lib/components";
import moment from "moment";

import styles from "assets/scss/components/homeWidgets/lastActu.module.scss";
import { InfoCard, InfoCardHeader, InfoCardBody } from "lib/components/InfoCard";
import FullNewsModal from "../../News/components/FullNewsModal";

const firestore = firebase.firestore;

const convertNews = (_news) => {
  if(_news?.version === "2") return _news;

  const { description, image, galery, ...others } = _news;

  return {
    images: image ? [image, ...galery] : galery,
    content: description.length > 0 ? `<p style="text-align: center;">${description}</p>` : "",
    ...others,
  };
};

const LastActus = () => {
  const [ui] = useUI();
  const [newsEtab, setNewsEtab] = useState([]);
  const [newsGrp, setNewsGrp] = useState([]);

  const [actus, setActus] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isFullImageModalOpen, setIsFullImageModalOpen] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);

  useEffect(() => {
      try {
        firestore().collection("establishments").doc(ui.user.establishment)
          .collection("blocks").doc("actus").collection("actus")
          .orderBy("date", "desc").onSnapshot(res => {
            let data = [];
            res.forEach(d => data.push({uid: d.id, ...d.data()}));
            setNewsEtab(data.filter(_a => _a?.isPublished !== false).map(_el => convertNews(_el)));
          });

          if(ui.groupement){
            let scope = ["national"];
            if(ui.establishment.region)scope.push(ui.establishment.region);
            firestore().collection("groupements").doc(ui.groupement)
            .collection("actus").where("type","in", scope).where("isPublished", "==", true).orderBy("date", "desc").limit(3).onSnapshot(snap => {
              let _data = [];
              snap.forEach(doc => _data.push({uid: doc.id, ...doc.data()}));
              setNewsGrp(_data.map(_el => convertNews(_el)));
            });
                }
      } catch (e) {
        console.error(e.message);
      }
      setLoading(false);
  }, []);

  useEffect(() => {
    let _actus = newsEtab.concat(newsGrp);
    _actus = _actus.sort((a,b) => b.date.toDate() - a.date.toDate()).slice(0,3);
    setActus(_actus);
    setLoading(false);
}, [newsEtab, newsGrp]);

  const handleNewsClick = (item) => {
    setItemSelected(item);
    setIsFullImageModalOpen(true);
  };

  return (
    <>
      <div className={styles.container}>
        {loading ? <Spinner /> : <>
          {!actus && actus.length < 1 ? <>
            <p>Aucune actualité pour votre établissement</p>
          </> :
            <div className={styles.actusContainer}>
            {actus.map((actu, indx) =>(
              <InfoCard height={"large"} key={indx}>
                  <InfoCardHeader
                    className={styles.cardHeaderColor}
                    title={actu.title}
                  ></InfoCardHeader>
                  <InfoCardBody image={actu.images?.[0]}>
                    <div className={styles.content}>
                      <div className={`${styles.quillContainer} ql-container ql-snow`}>
                        <div className={`${styles.quillEditor} ql-editor`} dangerouslySetInnerHTML={{ __html: actu.content }}></div>
                      </div>
                      <div className={styles.actuActions}>
                        <span className={styles.actuDate}>Publié le {moment(actu.date.toDate()).format("DD/MM/YYYY")}</span>
                        <Button color="primary" onClick={() => handleNewsClick(actu)} className={styles.button}>Consulter</Button>
                      </div>
                    </div>
                  </InfoCardBody>
                </InfoCard>              
            ))}
          </div>
          }
        </>}
      </div>
      <FullNewsModal
        isOpen={isFullImageModalOpen}
        toggle={() => {
          setIsFullImageModalOpen(false);

          const _currentNews = itemSelected;

          // Ne déselectionner l'actualité qu'une fois l'animation terminé (PS : la modale ne peut pas être ré-ouverte pendant ce temps)
          setTimeout(() => {
            setItemSelected((prevState) => prevState?.uid === _currentNews?.uid ? null : prevState);
          }, 300);
        }}
        item={itemSelected}
      />
    </>
  );
};

export default LastActus;